






import { Component, Prop, Vue } from 'vue-property-decorator';

const APP_BAR_HEIGHT = 46;
const SCROLLABLE_TOP_BAR_HEIGHT = 50;

@Component({})
export default class ScrollableTopBar extends Vue {
  @Prop({ type: String, required: false }) private targetElementId!: string;

  private targetElement: Element | undefined = undefined;
  private isTargetElementVisible: boolean = true;
  private barDistanceFromTop: number = -SCROLLABLE_TOP_BAR_HEIGHT;

  private get isFixed(): boolean {
    return !this.targetElementId;
  }

  private mounted(): void {
    if (this.isFixed) {
      this.showFixedBar();
    } else {
      this.targetElement = document.getElementById(this.targetElementId) as Element | undefined;
      if (!this.targetElement) {
        throw new Error(`Element with id ${this.targetElementId} was not found.`);
      }
      this.observeTargetVisibility();
      this.listenScrollAndSlideDownBarIfTargetElementIsNotLongerVisible();
    }
  }

  private observeTargetVisibility(): void {
    const setTargetElementVisibilityAfterPassingThreshold = (
      entries: IntersectionObserverEntry[],
    ) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio === 0) {
          this.isTargetElementVisible = false;
        } else if (!this.isTargetElementVisible) {
          this.isTargetElementVisible = true;
        }
      });
    };

    const observer = new IntersectionObserver(setTargetElementVisibilityAfterPassingThreshold, {
      root: null,
      rootMargin: `-${APP_BAR_HEIGHT}px`,
      threshold: [0],
    });

    observer.observe(this.targetElement!);
  }

  private listenScrollAndSlideDownBarIfTargetElementIsNotLongerVisible(): void {
    document.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => {
        if (this.isTargetElementVisible) {
          this.barDistanceFromTop = -SCROLLABLE_TOP_BAR_HEIGHT;
        } else {
          const targetElementClientRect = this.targetElement!.getBoundingClientRect();
          const bottomEdgeTargetElementDistanceToPageTop =
            targetElementClientRect.y + targetElementClientRect.height;
          const initialOffset = SCROLLABLE_TOP_BAR_HEIGHT - APP_BAR_HEIGHT;

          this.barDistanceFromTop = Math.min(
            APP_BAR_HEIGHT - bottomEdgeTargetElementDistanceToPageTop - initialOffset,
            APP_BAR_HEIGHT - 1,
          );
        }
      });
    });
  }

  private showFixedBar(): void {
    this.barDistanceFromTop = APP_BAR_HEIGHT - 1;
  }
}
